import { CategoryHeader } from '@we-make-websites/ui-lib';
import { NextSeo } from 'next-seo';
import { useContext } from 'use-context-selector';
import { Breadcrumbs } from 'components/breadcrumbs/Breadcrumbs';
import { PLPContext } from '../plpContext/PLPProvider';

/**
 * Collection Header Component (connected to PLP Context)
 */
export const CategoryHeaderConnected = () => {
  const plpContext = useContext(PLPContext);

  if (plpContext === undefined)
    throw new Error('PLPContent must be used within a PLPContext');

  const {
    desktopImage,
    mobileImage,
    merchandisedTitle,
    description,
    isLoading,
    backgroundColor,
    backgroundColorOnMobile,
    seo,
    textTheme: theme,
  } = plpContext;

  return (
    <>
      <NextSeo title={seo.title} description={seo.description} />
      <Breadcrumbs title={merchandisedTitle} />
      <CategoryHeader
        {...{
          desktopImage,
          mobileImage,
          title: merchandisedTitle,
          description,
          isLoading,
          backgroundColor,
          backgroundColorOnMobile,
          theme,
        }}
      />
    </>
  );
};
